@if (!viewSecondPanel) {
<div
  class="col se-p second-level-menu scroll-bar"
  [ngClass]="{ 'hide-listwrapper': viewUserList }"
>
  <div class="tabs is-centered is-marginless is-small is-mobile display-flex">
    <ul>
      <li routerLinkActive="is-active">
        <a
          class="is-semibold is-small"
          (click)="showCreateStudent()"
          [routerLink]="['/userandgroup/user']"
          >User</a
        >
      </li>
      <li routerLinkActive="is-active">
        <a
          class="is-semibold is-small"
          [routerLink]="['/userandgroup/group']"
          (click)="showGroupName()"
          >Lesson</a
        >
      </li>
    </ul>
  </div>
  @if (showSearchSec) {
  <div class="menu-options level is-marginless display-flex activeUserMobile">
    <div class="level-left">
      <div class="level-item">
        <div class="select is-small">
          <select [(ngModel)]="sortBy" (change)="getUserListSortAndSearch()">
            <option value="name">Sort A to Z</option>
            <option value="time">Sort by Recent</option>
          </select>
        </div>
      </div>
    </div>
    <div class="level-right">
      <div class="level-item">
        <a class="button is-small" (click)="showSearchbox('open')">
          <i class="fa fa-search"></i>
        </a>
        <a
          class="mobileViewBtn is-small button"
          title="Add User / Bulk Upload"
          [routerLink]="['/userandgroup/user/newuser']"
        >
          <i class="fa-solid fa-circle-plus"></i>
        </a>
        <!-- <a class="is-small button has-tooltip-left" data-tooltip="Create Group" >
            <i class=" fa-solid fa-circle-plus" aria-hidden="true"></i>
          </a> -->
        @if (!showBtnSpinner) {
        <a
          class="is-small button has-tooltip-left"
          data-tooltip="Send email to all In-active users"
          (click)="sendMailtoUser(listOfUsers)"
        >
          <i class="fa fa-envelope" aria-hidden="true"></i>
        </a>
        } @if (showBtnSpinner) {
        <a class="button is-loading is-small" style="min-width: 100px"></a>
        }
      </div>
    </div>
  </div>
  } @if (!showSearchSec) {
  <div class="menu-options level is-marginless searchBox-pad display-flex">
    <div class="level-left">
      <div class="level-item input-search-box">
        <div class="field">
          <p class="control has-icons-left has-icons-right">
            <!-- <input class="input" type="text" inputFocus [(ngModel)]="search" (keyup.enter)="getUserListSortAndSearch(0)" placeholder="Search"> -->
            <input
              class="input"
              type="text"
              inputFocus
              [(ngModel)]="search"
              (keyup)="searchInList.next($event)"
              placeholder="Search"
            />
            <!-- <a class="icon is-small is-left" (click)="getUserListSortAndSearch(0)" title="Search"> -->
            <a class="icon is-small is-left" title="Search">
              <i class="fa fa-search"></i>
            </a>
            <span class="input-bar"></span>
          </p>
        </div>
      </div>
    </div>
    <div class="level-right">
      <div class="level-item" (click)="showSearchbox('close')">
        <span class="icon is-small is-right search-return">
          <i class="fa fa-times-circle"></i>
        </span>
      </div>
    </div>
  </div>
  }
  <div
    class="list-wrapper scroll-bar list-overflow scrollUserandGroup"
    appInfiniteScroll
    (reachedBottom)="onScrollDown()"
  >
    <ul>
      @for (user of listOfUsers; track user) {
      <li class="cursor-pointer user-status" routerLinkActive="active">
        <div
          class="columns is-gapless display-flex"
          [routerLink]="['/userandgroup/user', user.user_id]"
        >
          <div class="column is-one-quarter">
            @if (user.user_icon) {
            <img [src]="profileUrl + user.user_icon" />
            } @if (!user.user_icon) {
            <empty-uname
              [userName]="user.first_name"
              [liProfile]="true"
            ></empty-uname>
            }
            <span class="icon is-small"></span>
          </div>
          <div class="column is-clearfix">
            <div class="is-pulled-left">
              <label
                class="is-size-6 is-capitalized"
                title="{{ user.first_name }}"
                >{{ user.first_name }}</label
              >
            </div>
            <div class="is-pulled-right">
              <span class="is-size-7 text-clr-grey timeAgo">{{
                user.createdAt | amTimeAgo
              }}</span>
              <i
                class="fa fa-stop"
                title="User status is {{
                  user.acc_active ? 'Active' : 'Deactive'
                }}"
                [ngClass]="{
                  'has-text-danger': !user.acc_active,
                  'has-text-success': user.acc_active
                }"
              ></i>
            </div>
          </div>
        </div>
      </li>
      }
      <pagination-loader
        [showFetchLoader]="showPaginateLoader"
      ></pagination-loader>
    </ul>
  </div>
</div>
} @if (totalRowCount > 0 && viewActionBtn) {
<div class="col th-p notification-content-wrapper">
  <header class="top-box-shadow">
    <div class="columns is-gapless is-vcentered display-flex">
      <figure class="has-text-centered">
        <i
          class="fa is-pulled-left"
          [ngClass]="{
            'fa-angle-double-left': !this.viewSecondPanel,
            'fa-angle-double-right': this.viewSecondPanel
          }"
          (click)="hideSecondPanel()"
        ></i>
      </figure>
      <div class="is-pulled-left">
        @if (!userCreationViewCtrl.showTable) {
        <span class="is-size-6 has-text-weight-semibold">{{
          userCreationViewCtrl.showForm ? "User Creation" : "Bulk Users Upload"
        }}</span>
        } @if (userCreationViewCtrl.showTable) {
        <span class="is-size-6 has-text-weight-semibold"
          >Bulk Users upload -
          <span class="has-text-link">{{ bulkUserFileName }}</span>
          Processed</span
        >
        }
      </div>
      <div class="column has-text-right is-size-6">
        @if (!userCreationViewCtrl.showTable && userCreationViewCtrl.showForm) {
        <div class="desk-view userMobileView">
          <a class="desk-icon">
            <button
              class="button is-small is-link is-outlined btndeskTopView"
              [routerLink]="['/userandgroup/user/newuser']"
            >
              <i class="fa-solid fa-circle-plus"></i> &nbsp;&nbsp;New User
            </button>
            <button
              class="button is-small is-link is-outlined isBtnMobileView"
              title="Create new User"
              [routerLink]="['/userandgroup/user/newuser']"
            >
              <i class="fa-solid fa-circle-plus" aria-hidden="true"></i>
            </button>
          </a>
          <a class="desk-icon">
            <button
              class="button is-small is-link is-outlined btndeskTopView"
              (click)="excelFileUploadSectionHandler()"
            >
              Bulk Users Upload
            </button>
            <button
              class="button is-small is-link is-outlined isBtnMobileView"
              title="Bulk Users Upload"
              (click)="excelFileUploadSectionHandler()"
            >
              <i class="fa fa-upload" aria-hidden="true"></i>
            </button>
          </a>
        </div>
        }
      </div>
      @if (userCreationViewCtrl.showTable) {
      <div class="column has-text-right">
        <div class="desk-view">
          <a class="desk-icon btnDeskIcon">
            @if (!userCreationViewCtrl.showForm) {
            <button
              class="button is-small is-link is-outlined"
              (click)="cancelUserList()"
            >
              Cancel
            </button>
            }
            <button
              class="deskViewBtn button is-link is-small mar-0-5"
              [ngClass]="{ 'is-loading': userCreationViewCtrl.startUpload }"
              (click)="createBulkUser()"
              [disabled]="userCreationViewCtrl.startUpload"
            >
              Save User Data
            </button>
            <!-- <button class="mobileViewBtn button is-link is-small mar-0-5"
                  [ngClass]="{'is-loading' : userCreationViewCtrl.startUpload}"
                  (click)="createBulkUser()"
                  [disabled]="userCreationViewCtrl.startUpload">
                  <i class="fa fa-save" aria-hidden="true"></i>
                </button> -->
          </a>
        </div>
      </div>
      }
    </div>
  </header>
  <div class="col contents is-marginless">
    <div class="scroll-bar">
      <div class="column">
        <div class="columns">
          <div
            class="column is-12"
            [ngClass]="{
              'is-two-thirds is-offset-one-quarter':
                userCreationViewCtrl.showForm
            }"
          >
            <!-- <div class="columns new-chat mar-top15"> -->
            @if (userCreationViewCtrl.showFileChoosen) {
            <div class="columns">
              <div class="column user-bulk-cr">
                <div class="has-text-left top-align">
                  <div class="columns is-mobile is-centered">
                    @if (!excelFileList) {
                    <div class="column bulk_two_thirds is-three-quarters">
                      <div class="card">
                        <div class="card-content" style="font-size: 14px">
                          <p class="mar-bot5">
                            This section helps you with “+ Bulk Users Upload,
                            Please note the following and proceed further.
                          </p>
                          <div class="right-align">
                            <ul class="">
                              <li>
                                When using Bulk upload, only normal user are
                                created i.e.,user-role ="User"
                              </li>
                              <li>
                                Please fill the data as mentioned in the sample
                                template file (
                                <i
                                  class="fa fa-download has-text-link"
                                  aria-hidden="true"
                                  style="cursor: pointer"
                                  (click)="getBulkUserTemplate()"
                                >
                                  click here</i
                                >
                                )
                              </li>
                              <li>All the fields in the files are mandatory</li>
                              <li>
                                Please recheck the uploaded file, if any error
                                occurs
                              </li>
                              <!-- <li></li> -->
                            </ul>
                          </div>
                          <div class="field has-text-centered">
                            <a
                              class="button is-small mar-0-5"
                              (click)="onCancelFileUploadSection()"
                              >Cancel</a
                            >
                            <div
                              class="file is-link is-small display-ib has-tooltip-top"
                              data-tooltip="Only upload xls file"
                            >
                              <label class="file-label" style="margin: 0 auto">
                                <input
                                  class="file-input"
                                  type="file"
                                  name="resume"
                                  (change)="onExcelFileChoosen($event)"
                                  #excelFile
                                  accept=".xls"
                                />
                                <span class="file-cta">
                                  <span class="file-label">
                                    Choose a File
                                  </span>
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    } @if (excelFileList) {
                    <div class="column bulk_two_thirds is-two-thirds">
                      <div class="card">
                        <div class="card-content">
                          <p class="mar-bot5 file-upload-nxt">
                            You have chosen the following file, to proceed
                            further please click on “Upload”
                          </p>
                          <!-- <p class="pad-5-10 has-text-link mar-bot5">{{excelFileList?.name}}</p> -->
                          <div class="has-text-centered">
                            <p class="has-text-link mar-bot5">
                              {{ excelFileList?.name }}
                            </p>
                          </div>
                          <div class="field has-text-centered">
                            <a
                              class="button is-small mar-0-5"
                              (click)="onCancelFileUploadSection()"
                              >Cancel</a
                            >
                            <a
                              class="button is-small is-dark mar-0-5"
                              (click)="onClearExcelFileChoosen()"
                              >Clear</a
                            >
                            <button
                              class="button is-small is-link mar-0-5"
                              [ngClass]="{
                                'is-loading': excelFileOpt.showProgress
                              }"
                              (click)="onUploadFileProcess()"
                              [disabled]="excelFileOpt.showProgress"
                            >
                              Upload
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>
            } @if (userCreationViewCtrl.showTable) {
            <div class="columns content-height-calc is-12 scroll-bar">
              <div class="column is-12">
                <article
                  class="message is-info"
                  style="margin-bottom: 1em !important"
                >
                  <div
                    class="message-body"
                    style="padding: 0.72em 1em !important"
                  >
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    Uploaded file has following information, please review it
                    and click on 'Save User Data' to complete the upload
                  </div>
                </article>
                @if (excelUserList.length > 0) {
                <table class="table is-striped is-fullwidth bulkuplTableView">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Roll Number</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Email</th>
                      <th>Gender</th>
                      <th>Phone Number</th>
                      <th>Lessons</th>
                      <!-- <th>Emp/Student Id</th> -->
                      <th>Action</th>
                      <!-- <th>Reg. Number</th>
                              <th>Role </th>
                              <th>Aadhar Card Number</th>
                              <th>Options</th>
                              <th>Address</th>
                              <th>City</th>
                              <th>State</th>
                              <th>Zip Postal</th>
                              <th>Pan Number</th>
                              <th>Other Id's</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    @for (user of excelUserList; track user; let i = $index) {
                    <tr>
                      <td>{{ i + 1 }}</td>
                      <td>{{ user.roll_number }}</td>
                      <td>{{ user.first_name }}</td>
                      <td>{{ user.last_name }}</td>
                      <td>{{ user.email_id }}</td>
                      <td>{{ user.gender }}</td>
                      <td>{{ user.phone_no }}</td>
                      <td>{{ user.group }}</td>
                      <!-- <td>{{user.emis_number}}</td> -->
                      <!-- <td>{{user.registration_number}}</td>
                                <td>{{user.address}}</td>
                                <td>{{user.city}}</td>
                                <td>{{user.zip_postal}}</td>
                                <td>
                                  <code class="html has-text-link">{{user.user_role}}</code>
                                </td>
                                <td>{{user.aadhaar_number}}</td>
                                <td>{{user.pan_number}}</td>
                                <td>{{user.other_ids}}</td> -->
                      <td>
                        <i
                          class="fa fa-trash-o"
                          aria-hidden="true"
                          title="Remove user"
                          (click)="removeUserFromListHandler(user)"
                        ></i>
                      </td>
                    </tr>
                    }
                  </tbody>
                </table>
                }
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}

<!-- <div class="modal welcome-window" [ngClass]="{'is-active': showWelcomeWindow}" *ngIf="is_tour_completed">
  <div class="modal-background"></div>
  <div class="modal-content">
    <div class="box" *ngIf="welcomeWindowName === 'welcome'">
      <div class="columns">
        <div class="column is-12 has-text-centered">
          <img [src]="'../../../../assets/images/welcome_chat.png'">
          <h2>Hi {{loggedUserDeatails?.first_name}}, Welcome to Canstring Class!</h2>
          <h4>Successfully signed up, now let us have a quick tour of the app.</h4>
        </div>
      </div>
      <div class="columns has-text-centered">
        <div class="column is-12">
          <a class="button is-link" (click)="showOnboarding()">Explore Canstring class</a>
        </div>
      </div>
    </div>
  </div>
  <button class="modal-close is-large" (click)="welcomeWindow()" aria-label="close"></button>
</div> -->

@if (viewActionBtn && totalRowCount === 0) {
<div class="empty-state" [ngClass]="{ 'empty-disabled': totalRowCount > 0 }">
  @if (!userCreationViewCtrl.showTable && userCreationViewCtrl.showForm) {
  <div class="has-text-centered box">
    <img [src]="'../../../../assets/images/notification_empty.svg'" />
    <p>No users record found. Please check the button below to create user</p>
    <a
      class="button is-link is-small mar-top15 mar-0-5"
      id="createStudent"
      [routerLink]="['/userandgroup/user/newuser']"
    >
      <span class="icon is-small">
        <i class="fa fa-plus is-small" style="font-size: 12px !important"></i>
      </span>
      <span>Create New User</span>
    </a>
    <!-- <a class="button is-link is-small mar-top15 mar-0-5" id="bulkStudents" (click)="excelFileUploadSectionHandler()" >
        <span class="icon is-small">
          <i class="fa fa-plus is-small" style="font-size: 12px !important;"></i>
        </span>
        <span>Bulk Users Upload</span>
      </a> -->
  </div>
  }
</div>
}

<router-outlet></router-outlet>
